"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

exports.default = filterData;
function filterData() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var scale = arguments[1];
    var date = arguments[2];

    var _scale$domain = scale.domain(),
        _scale$domain2 = _slicedToArray(_scale$domain, 2),
        min = _scale$domain2[0],
        max = _scale$domain2[1];

    return data.filter(function (d) {
        return date(d) >= min && date(d) <= max;
    });
}
//# sourceMappingURL=filterData.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/ansyn-event-drops/dist-es5/filterData.js
// module id = ../../../../ansyn-event-drops/dist-es5/filterData.js
// module chunks = vendor